
import React from 'react';
import { usePayment } from '@/context/PaymentContext';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Navbar } from '@/components/Navbar';
import Dashboard from '@/components/backoffice/Dashboard';
import InsightsPanel from '@/components/backoffice/InsightsPanel';
import TransactionTable from '@/components/TransactionTable';

const BackOffice = () => {
  const { transactions } = usePayment();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-8 pb-20">
        <h1 className="text-3xl font-bold mb-6">AI-Powered Back Office</h1>
        
        <Tabs defaultValue="dashboard" className="w-full">
          <TabsList className="mb-8">
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="database">Transaction Database</TabsTrigger>
            <TabsTrigger value="insights">AI Insights</TabsTrigger>
          </TabsList>

          <TabsContent value="dashboard">
            <Dashboard transactions={transactions} />
          </TabsContent>

          <TabsContent value="database">
            <Card>
              <CardHeader>
                <CardTitle>Transaction Database</CardTitle>
                <CardDescription>Complete transaction records with search and sort capabilities</CardDescription>
              </CardHeader>
              <CardContent>
                <TransactionTable transactions={transactions} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="insights">
            <InsightsPanel transactions={transactions} />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default BackOffice;
